import { Skeleton, ListItem, ListItemText } from "@mui/material";

const PointsSkeleton = ({ count }) => (
    <>
        {[...Array(count)].map((_, i) => (
            <ListItem key={i} disablePadding sx={{ mb: 2 }}>
                <ListItemText
                    primary={<Skeleton 
                        variant="text" 
                        width={150} 
                        height={26}
                        sx={{
                            bgcolor: "rgba(255,255,255,0.15)",
                            "&::after": {
                                background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)",
                            },
                        }}
                    />}
                />
            </ListItem>
        ))}
    </>
);

export default PointsSkeleton;
